<template>
  <el-dialog
      title="分配权限 "
      :append-to-body="true"
       :close-on-click-modal="false"
      :visible.sync="permissionVisible"
      width="40%"
      :before-close="closeView">
       <div  class="menu">
         <el-tree
         :render-after-expand="false"
            ref="tree"
            :data="permissionList"
            show-checkbox
            node-key="menuId"
            :check-strictly = "true"
            @check-change="checkChange"
            :default-checked-keys="defaultCheckedKeys"
            :props="defaultProps">
            <div class="centerRow" slot-scope="{ node,data }">
              <div class="treeNodeText">
                {{node.label}}
              </div>
              <div  class="childCheck">
                <childCheck
                v-if="data.buttonList && data.buttonList.length > 0"
                @updateIDs="updateIDs"
                :buttonList="data.buttonList"
                :node="node"
                :defaultBtnKeys="defaultBtnKeys">
                </childCheck>
                <!-- <el-checkbox v-for="(item,index) in data.buttonList" :key="index" v-model="item.buttonValue" :label="item.buttonName" ></el-checkbox> -->
              </div>
            </div>
          </el-tree>
       </div>
       <div slot="footer" class="dialog-footer">
        <el-button @click="closeView">取 消</el-button>
        <el-button type="primary" @click="submitForm" >确认分配</el-button>
      </div>
   </el-dialog>
</template>
<script>
import { listOwnerMenu, updateRoleTemplate } from '@/api/auth'
import childCheck from '@/components/common/childCheck'
import { mapGetters } from 'vuex'
export default {
  components: {
    childCheck
  },
  props: {
    permissionVisible: {
      type: Boolean
    },
    roleTempDetail: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data () {
    return {
      defaultProps: {
        children: 'childMenus',
        label: 'menuName'
      },
      permissionList: [],
      defaultCheckedKeys: [],
      defaultBtnKeys: null,
      menuIds: [],
      buttonIds: []
    }
  },
  computed: {
    ...mapGetters(['getCacheListOwnerMenu'])
  },
  created () {
    if (this.getCacheListOwnerMenu) {
      this.permissionList = JSON.parse(this.getCacheListOwnerMenu)
    } else {
      this.getListOwnerMenu()
    }
    this.defaultCheckedKeys = this.roleTempDetail.menuIds
    const keys = {}
    this.roleTempDetail.buttonIds.forEach(key => {
      keys[key] = true
    })
    this.defaultBtnKeys = keys
  },
  methods: {
    submitForm () {
      // this.ids.menuIds = this.menuIds
      // this.ids.buttonIds = this.buttonIds
      // this.closeView()
      const params = {
        roleTemplateId: this.roleTempDetail.roleTemplateId,
        roleRightGroupId: this.roleTempDetail.roleRightGroupId,
        roleName: this.roleTempDetail.roleName,
        remark: this.roleTempDetail.remark,
        organizationType: this.roleTempDetail.organizationType,
        menuIds: this.menuIds.join(','),
        buttonIds: this.buttonIds.join(',')
      }
      console.log('修改发送数据：', params)
      console.log(params)
      updateRoleTemplate(params).then(res => {
        res = res.data
        console.log('修改获取的信息：', res)
        if (res.code === 0 || res.code === 200) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.$emit('initPermissionList')
          this.closeView()
          // this.$emit('updateList')
          // this.$emit('closeDialog')
        }
      })
    },
    updateIDs () {
      console.log('updateIDs调用到了')
      // 点击时候更新menuIds、以及buttonIds

      const btnCheck = this.getBtnCheckedKeys()
      const btnArr = btnCheck.arr
      // this.ids.menuIds = this.$refs.tree.getCheckedKeys()
      // this.ids.buttonIds = btnArr
      this.menuIds = this.$refs.tree.getCheckedKeys()
      this.buttonIds = btnArr
      console.log('updateIDs更新后menuIds：', this.menuIds, ',this.buttonIds:', this.buttonIds)
    },
    getListOwnerMenu () {
      listOwnerMenu().then(res => {
        res = res.data
        console.log('获取用户对应的菜单data：', res.data)
        if (res.data) {
          this.permissionList = res.data
        }
      })
    },
    closeView () {
      this.$emit('closeView')
    },
    checkChange (data) {
      console.log('点击的data:', data)
      const node = this.$refs.tree.getNode(data.menuId)
      this.updateBtnList(node, data)// 更新buttonList引起子组件更新
      this.setNode(node)
      // 点击时候更新menuIds、以及buttonIds
      this.updateIDs()
    },
    // 递归设置子节点和父节点
    setNode (node) {
      if (node.checked) {
      // 如果当前是选中checkbox,则递归设置父节点和父父节点++选中
        this.setParentNode(node)
      } else {
      // 如果当前是取消选中checkbox,则递归设置子节点全部取消选中
        this.setChildNode(node)
      }
    },
    updateBtnList (node, data) {
      // 如果取消勾选，要把同级别目录下的按钮列表所有的check置为false
      if (!node.checked) {
        if (data.buttonList && data.buttonList.length > 0) {
          data.buttonList.forEach(item => {
            item.check = false
          })
        // data.buttonList = Object.assign([], data.buttonList)
        }
      }
    },
    // 递归设置父节点全部选中
    setParentNode (node) {
      if (node.parent) {
        for (const key in node) {
          if (key === 'parent') {
            node[key].checked = true
            this.setParentNode(node[key])
          }
        }
      }
    },
    // 递归设置子节点全部取消选中
    setChildNode (node) {
      if (node.childNodes && node.childNodes.length) {
        node.childNodes.forEach(item => {
          item.checked = false
          this.setChildNode(item)
        })
      }
    },
    getBtnCheckedKeys (menuList) {
      // 循环获取所有被选中的按钮，返回数组值
      const btnCheckArr = []
      const btnCheck = {}
      function getKeys (list) {
        list.forEach(item => {
          // 按钮循环
          if (item.buttonList && item.buttonList.length > 0) {
            item.buttonList.forEach(btnItem => {
              if (menuList) {
                // 直接将所有的按钮过滤回去
                if (btnItem.buttonId) {
                  btnCheckArr.push(btnItem.buttonId)
                  btnCheck[btnItem.buttonId] = btnItem.check
                }
              } else {
                // 过滤返回选中的按钮
                if (btnItem.check && btnItem.buttonId) {
                  btnCheckArr.push(btnItem.buttonId)
                  btnCheck[btnItem.buttonId] = btnItem.check
                }
              }
            })
          }
          // 菜单循环
          if (item.childMenus && item.childMenus.length > 0) {
            getKeys(item.childMenus)
          }
        })
      }
      if (menuList) {
        getKeys(menuList)
      } else {
        getKeys(this.permissionList)
      }
      console.log('this.permissionList:', this.permissionList)
      console.log('返回的两个数值：', { arr: btnCheckArr, check: btnCheck })
      return { arr: btnCheckArr, check: btnCheck }
      // this.permissionList.forEach()
    }
  }
}
</script>
<style lang="less" scope>
  .el-tree-node__content {
    height: initial !important;
  }
 .menu{
    .centerRow{
      display: flex;
      align-items: middle;
      width: 100%;
    }
    .childCheck{
      flex: 1;
    }
    .treeNodeText{
        display: flex;
        align-items: center;
        white-space: nowrap;
        flex: 0 0 90px;
    }
    /deep/ .el-tree-node {
      padding: 4px;
    }
    /deep/ .el-tree-node {
    white-space: normal;
    }
  }
</style>
